import errors from '@feathersjs/errors';
import type { Params } from '@feathersjs/feathers';

/** Carry the version belonging to the edited snapshot, never a later read. */
export function snapshotParams(version: unknown): Params {
  const value = version instanceof Date ? version.toISOString() : version;

  if (typeof value !== 'string' || Number.isNaN(Date.parse(value))) {
    throw new errors.BadRequest(
      'Reload this record before saving: its version is missing.',
      {
        code: 'missing_working_copy_version',
      },
    );
  }

  return { query: { ifUnmodifiedSince: value } };
}

// Enumerable symbols survive object spreads and cloneDeep, but never enter
// JSON payloads. Spatial items do not otherwise carry their enclosing row's
// version through the editor.
const snapshotVersion = Symbol('workingCopyVersion');

export function withSnapshotVersion<T extends object>(
  value: T,
  version: unknown,
): T {
  return Object.assign(value, { [snapshotVersion]: version });
}

export function snapshotVersionOf(value: object): unknown {
  return (value as { [snapshotVersion]?: unknown })[snapshotVersion];
}
